
import { Component, Vue, Prop, Model, Ref } from 'nuxt-property-decorator';
import { InputRadioGroup, StripeCreditCard, Alert } from 'fourwaves-shared/components';
import { PaymentMethod, InputOption, BillingInfoDto } from 'fourwaves-shared';

@Component({
  components: {
    InputRadioGroup,
    StripeCreditCard,
    Alert,
  },
})
export default class CheckoutPaymentMethods extends Vue {
  @Prop({ type: Object, required: true }) readonly billingInfo!: BillingInfoDto;
  @Prop(Boolean) readonly disableInvoicing!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly required!: boolean;
  @Prop(Boolean) readonly renew!: boolean;
  @Ref() readonly stripe?: StripeCreditCard;

  @Model('change', { type: String, default: null }) readonly value!: PaymentMethod | string;

  readonly PaymentMethod = PaymentMethod;

  get paymentMethods(): InputOption<PaymentMethod>[] {
    return [
      { id: PaymentMethod.Stripe, label: this.$t('checkout.payment.credit_card') },
      {
        id: PaymentMethod.Invoicing,
        label: this.$t('checkout.payment.invoice'),
        disabled: this.disableInvoicing,
        keepOpen: this.disableInvoicing,
      },
    ];
  }

  get accordionOptionIds(): PaymentMethod[] {
    return this.paymentMethods.map(option => option.id);
  }

  get stripePublishableKey() {
    return this.$config.stripePk;
  }

  public shouldRenderPaymentMethod(paymentMethod: PaymentMethod, option: InputOption) {
    const isOptionMatch = option.id === paymentMethod;
    return isOptionMatch && this.value === paymentMethod;
  }
}
